import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import { tokens } from "../../../../../theme";

interface MemoryThankYouCardProps {
  deceasedName: string;
  backgroundImage: string;
  logoImage: string;
}

export const MemoryThankYouCard: React.FC<MemoryThankYouCardProps> = ({
  deceasedName,
  backgroundImage,
  logoImage,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        width: 1080,
        height: 1080,
        bgcolor: colors.primary[900],
        overflow: "hidden",
        position: "relative",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        p: 10,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Logo */}
      <Box>
        <img src={logoImage} alt="Muzukuru Logo" width={250} />
      </Box>

      {/* Title + Subtitle */}
      <Box>
        <Typography
          sx={{
            color: "#614438",
            fontWeight: 700,
            fontSize: 52,
            lineHeight: 1.2,
            mb: 2,
          }}
        >
          Thank You for Sharing a Memory
        </Typography>
        <Typography sx={{ color: "#614438", fontSize: 32 }}>
          In loving memory of {deceasedName}
        </Typography>
      </Box>

      {/* Message */}
      <Box>
        <Typography
          sx={{
            color: colors.primary[700],
            mb: 3,
            lineHeight: 1.7,
            fontFamily: "Josefin Sans",
            fontSize: 28,
          }}
        >
          We deeply appreciate the time you took to write and share your
          thoughts during this difficult moment.
        </Typography>
        <Typography
          sx={{
            color: colors.primary[700],
            lineHeight: 1.7,
            fontSize: 28,
            fontFamily: "Josefin Sans",
          }}
        >
          Your message has now been added to {deceasedName.split(" ")[0]}
          &apos;s Memory Book, where it will be treasured as part of their
          lasting legacy.
        </Typography>
      </Box>

      {/* Signature */}
      <Box>
        <Typography
          sx={{ fontWeight: 500, color: "#614438", mb: 1, fontSize: 26 }}
        >
          From and on Behalf of the Muzukuru Team,
        </Typography>
        <Typography
          sx={{
            fontFamily: "cursive",
            color: "#614438",
            fontSize: 52,
            mb: 2,
          }}
        >
          Tawanda
        </Typography>
        <Typography sx={{ color: "#555", fontSize: 22, lineHeight: 1.6 }}>
          Phone: +263 776 402 402 | tawanda@muzukuru.co.zw | www.muzukuru.co.zw
          <br />
          46B Mount Pleasant Drive, Mount Pleasant, Harare, Zimbabwe
        </Typography>
      </Box>
    </Box>
  );
};

MemoryThankYouCard.propTypes = {
  deceasedName: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  logoImage: PropTypes.string.isRequired,
};
